<section id="planes" class="section section-pricing">
	<div class="container">
		<h2>Planes y precios</h2>
		<p class="section-lead">
			Empezá con el primer mes gratis y elegí el plan que mejor acompañe el crecimiento de tu negocio.
		</p>
		<p class="trial-banner">Primer mes gratis en todos los planes</p>
		<p class="pricing-note">
			Facturación mensual, sin permanencia y con la posibilidad de cambiar de plan cuando lo necesites.
		</p>

		<div class="pricing-grid two-cols">
			<article class="price-card">
				<h3>Básico</h3>
				<p class="plan-caption">Ideal para empezar a ordenar tu gestión de forma simple y accesible.</p>
				<p class="price">$40.000<span>/mes</span></p>
				<ul>
					<li>Hasta 2 usuarios</li>
					<li>Hasta 100 comprobantes por mes</li>
					<li>Gestión de clientes y seguimiento</li>
					<li>Presupuestos y cobros</li>
					<li>Acceso a módulos principales</li>
					<li>Soporte prioritario</li>
				</ul>
				<a class="btn btn-outline" href="#cta-final" (click)="choosePlan('Basico')">Elegir Básico</a>
			</article>

			<article class="price-card recommended">
				<p class="badge">Más elegido</p>
				<h3>Profesional</h3>
				<p class="plan-caption">La opción más conveniente para negocios que buscan más control, más
					productividad y una gestión más completa.</p>
				<p class="price">$60.000<span>/mes</span></p>
				<ul>
					<li>Hasta 5 usuarios</li>
					<li>Comprobantes ilimitados por mes</li>
					<li>Gestión de clientes y seguimiento</li>
					<li>Presupuestos y cobros</li>
					<li>Acceso a módulos principales</li>
					<li>Soporte prioritario</li>
				</ul>
				<a class="btn" href="#cta-final" (click)="choosePlan('Profesional')">Probar Profesional</a>
			</article>
		</div>
	</div>
</section>